import { Injectable } from '@angular/core';

import { FilterService, FilterSet } from 'app/modules/collection/services/filter.service';
import { WidgetGroup } from 'app/providers/bridge-api/dashboard.service';
import { StorageAccountService } from 'app/providers/storage-api/blender-account.service';
import { EnableClassTelemetry } from 'app/services/otel.service';
import { WidgetDataSource } from '../../../models';
import { Widget } from './../../../providers/bridge-api/dashboard.service';

@EnableClassTelemetry()
@Injectable()
export class CpppCalculationService {
  constructor(
    private filterService: FilterService,
    private accountService: StorageAccountService
  ) {}

  public async assembleReportOptions(
    widgetPayload,
    widgetDataSource: WidgetDataSource,
    widgetGroup: WidgetGroup
  ) {
    const accountMetadata = await this.accountService.groupFieldsSub.latest();

    const reportOptions = JSON.parse(JSON.stringify(widgetPayload));
    reportOptions.widgetDataSource = widgetDataSource;

    if (!widgetGroup?.isImpact) {
      return reportOptions;
    }

    reportOptions.scoringStrategy = 'AVERAGE';

    if (
      accountMetadata.metadata.some(
        (f) => f.fieldName === reportOptions.analyticItem && f.metadata?.rating
      )
    ) {
      reportOptions.scoringStrategy = widgetGroup.parameters.scoringStrategy;
      reportOptions.scoreRange = widgetGroup.parameters.driversRange;
      reportOptions.boxDirection = widgetGroup.parameters.boxDirection;
      reportOptions.boxSize = widgetGroup.parameters.boxSize;

      if (reportOptions.analyticItem === widgetGroup.parameters.dependentField) {
        reportOptions.scoreRange = widgetGroup.parameters.dependentRange;
      }
    }

    return reportOptions;
  }

  public assembleWidgetQueryOptions(
    widget: Widget,
    widgetDataSource: WidgetDataSource,
    widgetGroup: WidgetGroup,
    periodParam?: { first: string; last: string },
    initialQueryOptions?,
    comparisonFilterSet?: FilterSet
  ) {
    const widgetQueryOptions =
      initialQueryOptions ??
      this.filterService.getWidgetQueryOptions(
        widget,
        widgetDataSource,
        widgetGroup,
        comparisonFilterSet
      );

    if (periodParam) {
      Object.assign(widgetQueryOptions.filters.dates, { and: [] });

      const daterange = this.filterService.createDaterangeFilterFromPeriod(
        periodParam.first,
        periodParam.last
      );

      widgetQueryOptions.filters.dates.and.push(daterange);
    }

    return widgetQueryOptions;
  }
}
